import '../scss/auth.scss';
import Logo from '../assets/altronic-wordmark-black.svg';

function AccessDeniedPage() {
    const windowUrl = window.location.href;
    return (
        <div className="access-denied-wrapper">
            <div className='main-section'>
                <img src={Logo} className='logo'/>
                {(windowUrl.includes('localhost') || windowUrl.includes('-dev')) &&
                    <h2 className='env'>DEVELOPMENT</h2>
                }
                {windowUrl.includes('-test') &&
                    <h2 className='env'>TESTING</h2>
                }
                <h1 className={'access-denied-header'}>Access Denied</h1>
                <p className={'notice'}>You don't have permission to view this page.<br/>If you believe this is a mistake, please contact your administrator for assistance.</p>
            </div>
        </div>
    );
}

export default AccessDeniedPage;
